<mat-sidenav-container class="sidenav-container">
  <!-- Loading Overlay -->
  @if (isLoading()) {
    <div class="loading-overlay">
      <mat-spinner diameter="60"></mat-spinner>
      <p>Loading...</p>
    </div>
  }

  <mat-sidenav #sidenav mode="over" position="end" [opened]="sidenavOpened()">
    <div class="sidenav-content">
      @if (sidenavContext(); as context) {

      <div class="ivaap-wrapper">
        <app-ivaap
          [ivaapTemplateId]="sidenavContext()?.cardViz?.viz?.dashboard_id ?? ''"
          [ivaapDatasetIds]="sidenavContext()?.cardViz?.viz?.ivaap_url ?? []"
          [ivaapType]="sidenavContext()?.cardViz?.viz?.type ?? 'template'"
        />
      </div>

      <div class="context-container">
        <h2>Context</h2>

        <div class="context-info">
          <span
            >Sample reply: OK‑53 is one of the wells that make up the Okan
            Field, a long‑producing offshore oil and gas field in Nigeria that
            is developed through clusters of wells spread across distinct
            structural areas. Within the field, OK‑53 sits in the Main Block,
            contributing to production from the central part of this large,
            fault‑segmented field alongside many neighboring wells.</span
          >
        </div>
      </div>

      }

      <div class="sidenav-actions">
        <button mat-raised-button color="primary" (click)="addToCanvas()">
          Add to Canvas
        </button>
        <button mat-raised-button (click)="closeSidenav()">Cancel</button>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="canvas-wrapper">
      <div class="toolbar">
        <button class="toolbar-btn" (click)="recenter()" title="Re-center View">
          <span>🎯</span> Re-center
        </button>
        <button class="toolbar-btn" (click)="resetZoom()" title="Reset Zoom">
          <span>🔍</span> Reset Zoom
        </button>
      </div>

      <div class="world-wrapper">
        <div #worldContainer class="world-container"></div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
